import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=3651e08d&scoped=true&"
import script from "./TemplateEditor.vue?vue&type=script&lang=js&"
export * from "./TemplateEditor.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=3651e08d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3651e08d",
  null
  
)

export default component.exports